import { useMemo } from "react"
import { getOutletFilterOptions } from "helpers/general-helper"

/**
 * Dropdown filter outlet standar atalla-cms (permintaan user 240726).
 *
 * Opsi = 2 grup ("Semua Outlet" = entitas user non-HO, "HO" = outlet 1 & 15) lalu
 * outlet individual terurut ascending by id — dari getOutletFilterOptions().
 *
 * `value` menyimpan nilai filter (sentinel grup GRP_ALL/GRP_HO atau id outlet).
 * Situs pemakai me-resolve nilai ini ke param request via resolveOutletFilter().
 *
 * Props tambahan (className, title, dll) diteruskan ke <select>. `includeAll`
 * menambah opsi kosong "Semua" di atas (jarang dipakai — grup sudah menggantikan).
 */
export default function OutletFilterSelect({
  value,
  onChange,
  disabled = false,
  className = "",
  title = "Outlet",
  includeAll = false,
  allLabel = "Semua",
  options: optionsProp,
  ...rest
}) {
  // `options` opsional: list pembelian mengirim opsi LINTAS-ENTITAS (all outlets)
  // supaya user Vision tetap bisa memilih outlet HO Atalla (id 1). Default = standar
  // entity-scoped.
  const options = useMemo(() => optionsProp ?? getOutletFilterOptions(), [optionsProp])

  return (
    <select
      value={value ?? ""}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={disabled}
      className={className}
      title={title}
      {...rest}
    >
      {includeAll && <option value="">{allLabel}</option>}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  )
}
